import { useContext, useCallback } from 'react';
import { createContext, useState } from 'react';

const WLoadingContext = createContext({
  open: false,
  setOpen: () => {},
});

function WLoadingProvider({ children }) {
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <WLoadingContext.Provider value={{ open, handleClose, handleOpen }}>
      {children}
    </WLoadingContext.Provider>
  );
}

const useWLoading = () => {
  const context = useContext(WLoadingContext);
  if (!context) {
    throw new Error('useWLoading must be used within a WLoadingProvider');
  }
  return context;
};

export { WLoadingContext, WLoadingProvider, useWLoading };
